<template>
  <div style="padding: 20px; background: #fff;">
    <div class="flex just-between">
      <div>
        <el-button type="primary" plain icon="el-icon-plus" size="small" @click="handleAdd()">增加</el-button>
      </div>
      <el-form :inline="true" :model="queryForm" class="demo-form-inline">
      <el-form-item label="启用状态">
        <el-select v-model="queryForm.enable" placeholder="启用状态" size="small" clearable>
        <el-option :value="1" label="启用"></el-option>
        <el-option :value="0" label="停用"></el-option>
      </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="small" @click="getDataList">查询</el-button>
      </el-form-item>
    </el-form>
    </div>
    <el-table style="width:100%;border:none;"
    :data='dataList'
    :header-cell-style="{background: '#409EFF',color: '#fff'}">
      <el-table-column type='index' label='序号' width="60"></el-table-column>
      <el-table-column prop="name" label="条目名称" width="200"></el-table-column>
      <el-table-column prop="info" label="条目信息"></el-table-column>
      <el-table-column prop="enable" label="启用状态" width="120">
        <template slot-scope="scope">
          <el-tag size="small" type="success" v-if="scope.row.enable">启用</el-tag>
          <el-tag size="small" type="danger" v-if="scope.row.enable === false">停用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sortCode" label="排序码" width="100"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="small" icon="el-icon-edit" style="margin-right:10px;" @click="handleEdit(scope.row)">修改</el-button>
          <el-button size="small" icon="el-icon-delete" @click="handleRemove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" :close-on-click-modal="false" :width="dialog.width" @closed="closedDialog">
      <el-form :model="editForm" :rules="rules" ref="editForm">
        <el-form-item prop="name" label="条目名称" :label-width="dialog.labelWidht">
          <el-input v-model="editForm.name" style="width: 360px" placeholder="请输入条目名称" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="info" label="条目信息" :label-width="dialog.labelWidht">
          <el-input v-model="editForm.info" style="width: 360px" placeholder="请输入条目信息" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="enable" label="启用状态" :label-width="dialog.labelWidht">
          <el-radio v-model="editForm.enable" :label="true">启用</el-radio>
          <el-radio v-model="editForm.enable" :label="false">停用</el-radio>
        </el-form-item>
        <el-form-item prop="sortCode" label="排序码" :label-width="dialog.labelWidht">
          <el-input type="text" v-model="editForm.sortCode" style="width: 360px" placeholder="请输入排序码（数字）" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    return {
      queryForm: {
        enable: null
      },
      dataList: [],
      dialog: {
        id: '',
        title: '',
        visible: false,
        width: '600px',
        labelWidht: '120px'
      },
      editForm: {},
      rules: {
        name: [{ required: true, message: '请输入条目名称', trigger: 'blur' }],
        info: [{ required: true, message: '请输入条目名称', trigger: 'blur' }],
        enable: [{ type: 'boolean', required: true, message: '请选择状态', trigger: 'change' }],
        sortCode: [{ required: true, message: '请输入排序码', trigger: 'blur' },
        { pattern: /^[0-9]\d*$/, message: '排序码需为正整数', trigger: 'blur' }]
      }
    }
  },
  methods: {
    getDataList () {
      this.dialog.visible = false
      this.$api.website.getInfoItemList(this.queryForm).then(res => {
        if (res.code === 200) {
          this.dataList = res.data.content
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleAdd() {
      this.dialog.id = ''
      this.dialog.title = '增加信息条目'
      this.dialog.visible = true
      this.editForm = {
        name: '',
        info: '',
        enable: true,
        sortCode: null
      }
      this.$refs.editForm?.resetFields();
    },
    handleEdit(data) {
      this.dialog.id = data.id
      this.dialog.title = '修改信息条目'
      this.dialog.visible = true
      this.$refs.editForm?.resetFields();
      this.$api.website.getInfoItem(data.id).then(res => {
        if (res.code === 200) {
          this.editForm = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleSave() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$api.website.saveInfoItem(this.editForm, this.dialog.id).then(res => {
            if (res.code === 200) {
              this.$message.success("保存成功")
              this.getDataList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      })
    },
    handleRemove(data) {
      this.$confirm('确定要删除信息条目【' + data.name + '】吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        this.$api.website.removeInfoItem(data.id).then(res => {
          if (res.code === 200) {
            this.getDataList()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },
    closedDialog() {
      this.$refs.editForm.resetFields()
    }
  },
  mounted () {
    this.getDataList()
  }
}
</script>

<style>

</style>
